import { RootState } from '../types'

export const getMainAdminSelector = (state: RootState) => state.admin

export const getAdminSelector = (state: RootState) => state.admin.admin
